import {
  getGroupNodeKey,
  getLayerNodeKey,
} from '../../../layers/tree/mapLayersTreeKeys.ts';
import { type ILayerCatalogLevels } from './parseLayerCatalogLevels.ts';

/**
 * Filtra i livelli e i gruppi di un catalogo in base alla selezione fatta
 * nell'albero di anteprima (checkbox di Ant Design).
 *
 * Le chiavi dei nodi sono ancorate a `code`/`name` (vedi `mapLayersTreeKeys`).
 * Un layer è incluso se la sua chiave è spuntata; un gruppo se è spuntato
 * esplicitamente oppure se è referenziato da un layer selezionato, così che il
 * riferimento `IMapLayer.group` non resti mai orfano.
 */
export function filterCatalogLevelsBySelection(
  levels: ILayerCatalogLevels,
  checkedKeys: string[],
): ILayerCatalogLevels {
  const checked = new Set(checkedKeys);

  const layers = levels.layers.filter(layer =>
    checked.has(getLayerNodeKey(layer.code)),
  );

  const referencedGroups = new Set(layers.map(layer => layer.group));

  const groups = levels.groups.filter(
    group =>
      checked.has(getGroupNodeKey(group.name)) ||
      referencedGroups.has(group.name),
  );

  return { layers, groups };
}
